(function () {
  if (!('IntersectionObserver' in window)) return;

  function initSwiper(swiper) {
    if (swiper.dataset.swipeReady) return;

    var track = swiper.querySelector('.product-item__swipe-track');
    var dots = swiper.querySelectorAll('.product-item__swipe-dot');
    if (!track || dots.length < 2) return;

    var slides = track.querySelectorAll('.product-item__swipe-slide');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.intersectionRatio < 0.6) return;
        var index = Array.prototype.indexOf.call(slides, entry.target);
        if (index < 0) return;
        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('is-active', i === index);
        }
      });
    }, { root: track, threshold: 0.6 });

    for (var s = 0; s < slides.length; s++) {
      observer.observe(slides[s]);
    }

    swiper.dataset.swipeReady = 'true';
  }

  function scan() {
    var swipers = document.querySelectorAll('.product-item__swipe');
    for (var i = 0; i < swipers.length; i++) {
      initSwiper(swipers[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', scan);

  if ('MutationObserver' in window) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        scan();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();